import {Entity} from '@s-ui/domain'

import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'

export class PackSellerValueObject extends Entity {
  #id
  #legacyId
  #type

  constructor({id, legacyId, type}) {
    super()
    this.#id = id
    this.#legacyId = legacyId
    this.#type = type
  }

  static createFromListingApi({pack}) {
    return new PackSellerValueObject({
      id: pack.legacyId ? IdSharedValueObject.createFromPrimitives({id: pack.legacyId}) : {},
      legacyId: pack.legacyId ? IdSharedValueObject.createFromPrimitives({id: pack.legacyId}) : {},
      type: pack.type
    })
  }

  get hasPack() {
    return Boolean(this.#type)
  }

  get id() {
    return this.#id.value
  }

  get legacyId() {
    return this.#legacyId.value
  }

  get type() {
    return this.#type
  }

  get value() {
    return {
      id: this.#id.value,
      legacyId: this.#legacyId.value,
      type: this.#type
    }
  }
}
